import { TagManager } from '@navent-jobs/config'
import { getCiudadProvincia } from './commons/localization'

export const DataLayers = {
  onload: ({ aviso, seccion }) => {
    /**
     * Debe dispararse cuando realiza el onload de la página de Ficha Aviso
     *
     * El objetivo es trackear las especificaciones del Aviso en el que se encuentra el usuario
     * seccion '{Aviso|Landing|Aviso Similar|Recomendados|Alertas|postLead|Modal offline}',
     */

    return {
      idAviso: aviso.id,
      tipoAnuncio: aviso.planPublicacion.nombre,
      empresa: aviso.empresa.denominacion,
      ubicacion: seccion,
      fechaPublicado: aviso.fechaPublicacion,
      area: aviso.area.nombre,
      areaId: aviso.area.id,
      subarea: aviso.subArea.nombre,
      subareaId: aviso.subArea.id,
      ciudad: aviso.localizacion.provinciaDetalle,
      barrio: aviso.localizacion.localidadDetalle,
      estado: aviso.estado,
      tipoPuesto: aviso.tipoTrabajo.nombre,
      aptoDiscapacitado: aviso.aptoDiscapacitados,
    }
  },
  irAlAviso: () => {
    return TagManager.Push({
      event: 'trackEvent',
      eventCategory: 'Listado',
      eventAction: 'Ir al Aviso',
    })
  },
  switchEntreSolapas: (eventLabel: string) => {
    const { pathname } = window.location
    let eventCategory
    if (pathname.includes('/empleos/')) {
      eventCategory = 'Aviso'
    } else {
      eventCategory = 'Listado'
    }

    return TagManager.Push({
      event: 'trackEvent',
      eventCategory,
      eventAction: 'Switch entre solapas',
      eventLabel,
    })
  },
  empleosRelacionadosOnClick: (avisoData, activeCardPosition) => {
    /**
     * El objetivo es trackear los clicks que recibe un aviso relacionado, y el detalle del mismo.
     *
     * Debe dispararse cuando el usuario hace click sobre uno de los avisos relacionados.
     */

    const { ciudad, provincia } = getCiudadProvincia(avisoData)

    TagManager.Push({
      event: 'clickAviso',
      fechaPublicado: avisoData.fechaPublicacion.split(' ')[0].trim(),
      idAviso: avisoData.id,
      tipoAnuncio: avisoData.planPublicacion.nombre,
      empresa: avisoData.empresa,
      area: avisoData.area,
      subarea: avisoData.subarea,
      ciudad,
      provincia,
      posicionAviso: activeCardPosition,
      ubicacion: 'Avisos recomendados', // pronto se trackeará en el último paso de carta
    })
  },
}
